import React from "react";
import { Pie } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";

// Register chart components
ChartJS.register(ArcElement, Tooltip, Legend);

const NewBusinessStatusChart = ({ data }) => {
    if (!data || data.length === 0) {
        return <p>No status data available.</p>;
    }

    // Extract labels and values
    const labels = data.map(item => item.statusDesc);
    const values = data.map(item => item.statusCount);

    // Define up to 5 color variations (extendable if needed)
    const backgroundColors = [
        "#4e79a7", // Blue
        "#f28e2c", // Orange
        "#e15759", // Red
        "#76b7b2", // Teal
        "#59a14f", // Green
    ];

    const chartData = {
        labels,
        datasets: [
            {
                label: "Number of Policies",
                data: values,
                backgroundColor: backgroundColors.slice(0, values.length),
                borderWidth: 1,
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    font: { size: 13 },
                    color: "#333",
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.label || "";
                        const value = context.parsed || 0;
                        return `${label}: ${value.toLocaleString()} policies`;
                    },
                },
            },
        },
    };

    return (
        <div style={{ width: "100%", maxWidth: "400px", margin: "0 auto" }}>
            <Pie data={chartData} options={options} />
        </div>
    );
};

export default NewBusinessStatusChart;
